// @ts-nocheck
import {
    chain,
    CheckAutocompleteModel as BaseCheckAutocompleteModel,
} from "@insite/client-framework/Store/CommonHandlers/StartSearch";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

const normalizeSearchText = (value?: string) =>
    (value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

export const CheckAutocompleteModel = createChainHandler("CheckAutocompleteModel", chain, props => {
    /* Store Custom Code - Start */
    const { autocompleteModel, query } = props.parameter;
    const normalizedQuery = normalizeSearchText(query);

    if (autocompleteModel?.products?.length === 1) {
        props.redirectUrl = autocompleteModel.products[0].url;
        return;
    }

    if (autocompleteModel?.categories?.length && normalizedQuery) {
        const exactMatchedCategories = autocompleteModel.categories.filter(
            category => normalizeSearchText(category.title) === normalizedQuery,
        );

        if (exactMatchedCategories.length === 1) {
            props.redirectUrl = exactMatchedCategories[0].url;
        }
    }
    /* Store Custom Code - End */
});

replaceInChain(chain, BaseCheckAutocompleteModel, CheckAutocompleteModel);
